export interface Paginator {
  data?: any[];
  paginatorInfo?: Record<string, any>;
}

export function mergePagination(
  existing: Readonly<Paginator> | undefined,
  incoming: Readonly<Paginator>,
  { args }: { args: Record<string, any> | null },
): Paginator {
  if (!args) {
    throw new Error('Can not merge incoming data if args are null!');
  }

  const { first, page = 1 } = args;

  if (typeof first !== 'number') {
    throw new Error('First must be a number!');
  }

  if (first <= 0) {
    throw new Error('First must be a positive number!');
  }

  if (typeof page !== 'number') {
    throw new Error('Page must be a number!');
  }

  if (page <= 0) {
    throw new Error('Page must be a positive number!');
  }

  const incomingData = incoming.data || [];

  if (
    existing === undefined ||
    existing.data === undefined ||
    existing.data.length === 0 ||
    page === 1
  ) {
    return {
      data: incomingData.slice(),
      paginatorInfo: incoming.paginatorInfo,
    };
  }

  const startIndex = first * (page - 1);
  const mergedData = existing.data.slice(0, startIndex);

  mergedData.push(...incomingData);

  return {
    data: mergedData,
    paginatorInfo: incoming.paginatorInfo,
  };
}
